import './style.css';
import './ui/art.css';
import { App } from './ui/app';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('#app mount point missing');

new App(root).start();
